import React from "react";
import { Link } from "react-router-dom";

import { 
    Accordion, 
    AccordionItem, 
    AccordionItemButton, 
    AccordionItemHeading, 
    AccordionItemPanel 
} from "react-accessible-accordion";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ChatRightText } from "react-bootstrap-icons";

import "../css/accordion-help.css";


export const FrequentlyAskedQuestions = () => {


    return (
        <div>
            <h2> <ChatRightText size={28} /> Frequently Asked Questions </h2>
            <hr/>
            <br/>
            <Accordion style={{fontSize: '18px'}} allowMultipleExpanded={true} allowZeroExpanded >
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            <b>Are there any refunds for services not utilized? </b>
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                            Refunds are allowed for services not utilized. 
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            <b> How do I get my refund for Police and Court bails? </b>
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                        Both police bail and court bail refunds are dependent on the process of the justice systems in the country through the decision of the Courts system. Refunds other than police or court bail are advised through a letter to Department of Finance through the respective national government agency.
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            <b> How long does it take for a refund to be made?  </b>
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                            It depends on the nature of the refund but normally two week maximum waiting time.
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            <b> Who has the authority to amend or change fees and rates? </b>
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                            The Secretary for Finance in consultation with the line agencies. 
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            <b> Can I pay fees at cash office with cash? </b>
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                            No. Cash payments are not allowed in all cash office. 
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            <b> How do I pay for fees without a bank card? </b>
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                            Clients without bank cards can pay their fees by direct bank deposits, the cash office will issue government official receipts of fee payment upon receipt of bank deposit slips from the client.  
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            <b> What happens after payment for the service is made and there is an error in the receipt details for example, name? </b>
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                            The receipt will be cancelled and a new receipt will be re-issued with the amended details. 
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            <b> What happens if I pay for a service and I do not use the service immediately? </b>
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                            It depends on the government service that you have applied for. For example, police clearance on character checks for those seeking employment or interviews with prospective employers or issuance of passport or visa payments. Other fees are compulsory and by law must be paid annually including land rental payment, regulatory fees/charges, permits and licenses. 
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            <b> How do I know the amount of fee to pay at the cash office? </b>
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                            The amount of fees are available in the portal displayed under the respective agency’s list of services.
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            <b> Can I use a personal cheque to pay for a fee? </b>
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                            No. Personal cheques are not allowed.
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            <b> If I lost my receipt before accessing the government service, what happens? </b>
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                            You can be able to retrieve a copy of your receipt online. A One Time Password (OTP) is generated to the mobile phone of the person who paid for the service for validation before a copy is made available to download. 
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            <b> If I have difficulty logging into the portal to make a payment who shall assist me? </b>
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <p>
                            You can call (+675) 7998 6000 for assistance or go to the administration portal and read the instruction manual on how to access the portal.
                        </p>
                    </AccordionItemPanel>
                </AccordionItem>
            </Accordion>
            <br/>
            <div>
                <SVG 
                    src={toAbsoluteUrl('/media/svg/files/pdf.svg')}  
                    style = {{ width: "60px", height:"60px"}}
                />
                <Link to='/media/files/DOF_FAQs.pdf' target='_blank' download> 
                    <span className="h6"> Download FAQs </span> 
                </Link>
            </div>
        </div>
    )
};